/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom separator`)
};

const es_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separador personalizado`)
};

const de_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenes Trennzeichen`)
};

const nl_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepast scheidingsteken`)
};

const fr_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séparateur personnalisé`)
};

const it_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separatore personalizzato`)
};

const pt_br2_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separador personalizado`)
};

const pt_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separador personalizado`)
};

const ja_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムセパレーター`)
};

const zh_tr_custom_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义分隔符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_custom_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_custom_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_custom_label", locale)
	if (locale === "en") return en_tr_custom_label(inputs)
	if (locale === "es") return es_tr_custom_label(inputs)
	if (locale === "de") return de_tr_custom_label(inputs)
	if (locale === "nl") return nl_tr_custom_label(inputs)
	if (locale === "fr") return fr_tr_custom_label(inputs)
	if (locale === "it") return it_tr_custom_label(inputs)
	if (locale === "pt-BR") return pt_br2_tr_custom_label(inputs)
	if (locale === "pt") return pt_tr_custom_label(inputs)
	if (locale === "ja") return ja_tr_custom_label(inputs)
	return zh_tr_custom_label(inputs)
};